module.exports = "\n<Checkbox-group\n  :model.sync=\"disabledGroup\"\n  :type=\"type\"\n  :shape=\"shape\"\n  :style=\"editorStyle\"\n  :id=\"id\"\n>\n  <Checkbox value=\"香蕉\"></Checkbox>\n  <Checkbox value=\"苹果\"></Checkbox>\n  <Checkbox value=\"西瓜\"></Checkbox>\n</Checkbox-group>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/components/checkbox/src/index.vue
// module id = 2320
// module chunks = 38